import mixpanelBrowser from 'mixpanel-browser';

class MixpanelWrapperClient {
    constructor(token) {
        mixpanelBrowser.init(token);
    }

    track(event, properties = {}) {
        mixpanelBrowser.track(event, properties);
    }

    identify(userId) {
        mixpanelBrowser.identify(userId);
    }
}

export default new MixpanelWrapperClient('65500d59158e9534bcb6337bcfa2b6bb'); 